<template>
  <div>
    <page-main
      :tableData="tableData"
      :tablePage="page"
      :loading="loading"
      @reload="reload"
      @openEditFormDialog="openEditFormDialog"
    >
      <page-header
        ref="header"
        slot="header"
        @query="getData"
        @reset="resetPage"
        @openEditFormDialog="openEditFormDialog"
      />
      <pagination
        size="mini"
        align="right"
        slot="pager"
        :current-page="page.curPage"
        :page-size="page.pageSize"
        :page-total="page.pageTotal"
        @change="handlePaginationChange"
      />
    </page-main>
    <el-dialog
      v-if="editFormDialogOptions.visible"
      show-close
      visible
      width="700px"
      :title="editFormDialogOptions.title"
      :close-on-click-modal="false"
      :before-close="() => $refs.editForm.cancel()"
    >
      <dict-options-edit-form
        ref="editForm"
        :dictDescription="editFormDialogOptions.dictDescription"
        :dictType="editFormDialogOptions.dictType"
        :keyID="editFormDialogOptions.keyID"
        :disabled="editFormDialogOptions.disabled"
        :params="editFormDialogOptions.params"
        @reload="reload"
        @close="closeEditFormDialog"
      />
      <span slot="footer">
        <el-button size="small" @click="$refs.editForm.cancel()">{{
          this.$l('INDEX.btn_cancel') || '取消'
        }}</el-button>
        <el-button type="primary" size="small" @click="$refs.editForm.save()">{{
          this.$l('INDEX.btn_save') || '保存'
        }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import PageMain from './main'
import PageHeader from './header'
import BaseTable from '@/mixins/base-table'
import DictOptionsEditForm from '../edit-form/index'
import store from '../../store'
export default {
  components: {
    PageHeader,
    PageMain,
    DictOptionsEditForm
  },
  mixins: [BaseTable],
  data() {
    return {
      usePage: true,
      editFormDialogOptions: {
        visible: false,
        keyID: '',
        companyCode: ''
      }
    }
  },
  computed: {
    selected() {
      return store.state.selected
    }
  },
  watch: {
    selected() {
      this.getData()
    }
  },
  methods: {
    getData(form) {
      if (!this.selected || !this.selected.dictType) return
      this.loading = true
      this.$api
        .masterBizDictOptionsListApi({
          dictType: this.selected.dictType,
          ...form,
          ...this.page
        })
        .then((res) => {
          this.loading = false
          this.setData(res)
        })
        .catch(() => {
          this.loading = false
        })
    },
    openEditFormDialog({ type, params = {} }) {
      if (!this.selected || !this.selected.dictType) {
        this.$message.warning(
          this.$l('form_label_tip_select_dict') || '请选选择一个大类'
        )
        return
      }
      const types = {
        edit: this.$l('form_label_dictionary_edit') || '编辑字典选项信息',
        add: this.$l('form_label_dictionary_add') || '添加字典选项信息'
      }
      this.editFormDialogOptions = {
        visible: true,
        type,
        title: types[type],
        keyID: params.keyID,
        dictType: this.selected.dictType,
        dictDescription: this.selected.dictDescription,
        companyCode: params.companyCode
      }
    },
    closeEditFormDialog() {
      this.editFormDialogOptions.visible = false
    }
  }
}
</script>
